const industries = () => {
    const onChangeUrl = function () {
        const url = $(this).data("url");
        console.log(url);
        window.history.pushState('', '', url)
    }

    const handleMenuDesktop = () => {
        const $menuList = $(".industry-list-menu");
        const $contentList = $(".industry-list");

        $menuList.on("click", ".industry-menu-item", function () {
            const $current = $menuList.find(".industry-menu-item.active");
            if ($current.length) {
                const index = $current.index()
                $current.removeClass("active");
                $contentList.find(".industry-item").eq(index).find(".collapse").fadeOut(300, () => {
                    const newIndex = $(this).index();
                    $contentList.find(".industry-item").eq(newIndex).find(".collapse").fadeIn(300)
                })
            }
            else {
                //fix cho trường hợp menu ngành hàng, không có menu active trước
                const newIndex = $(this).index();
                $contentList.find(".industry-item").eq(newIndex).find(".collapse").fadeIn(300)
            }
            $(this).addClass("active");
            onChangeUrl.bind(this)()
        });
    }

    const handleMenuMobile = () => {
        $(".industry-item").on("click", ".head", function () {
            $item = $(this).parent()
            onChangeUrl.bind($item)()
        })
    }

    const initProductSlide = (id) => {
        const $parents = $(`.industry-list ${id ? id : ''} .product-images`);
        $parents.each(function () {
            const $parent = $(this);
            const $main = $parent.find(".slick-main");
            const $thumb = $parent.find(".slick-thumb");
            $main.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                asNavFor: $thumb,
                lazyLoad: true,
                mobileFirst: true,
                prevArrow: $parent.find(".slick-main-prev"),
                nextArrow: $parent.find(".slick-main-next")
            });
            $parent.find(".slick-thumb").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: $main,
                dots: false,
                centerMode: true,
                focusOnSelect: true,
                lazyLoad: true,
                arrows: true,

                prevArrow: $parent.find(".slick-thumb-prev"),
                nextArrow: $parent.find(".slick-thumb-next")
            })
        });
        console.log("vao...")
        $(document).on('shown.bs.modal', '.product-modal', function (e) {
            const $parent = $(this).find(".product-images")
            const $main = $parent.find(".slick-main");
            const $thumb = $parent.find(".slick-thumb");
            $main.slick("refresh");
            $thumb.slick("refresh");
        })
    }

    handleMenuDesktop();
    handleMenuMobile();
    window.initProductSlide = initProductSlide;
}

module.exports = industries
